export const UPDATE_CANCELLATION_REASONS = "UPDATE_CANCELLATION_REASONS";
export const UPDATE_FACILITIES_LIST = "UPDATE_FACILITIES_LIST";

